<script setup lang="ts">
const { t } = useI18n()

useSeoMeta({
  title: t('pages.products.meta.title'),
  description: t('pages.index.meta.description'),
})

// definePageMeta({
//   scrollToTop: false,
// })

const route = useRoute()

const { locale } = useI18n()

const { data: smartFiltersData, status } = await useLazyAsyncData(
  'smartFilters_' + locale.value,
  () => createProductSmartFiltersRepository().getSmartFilters(),
  {
    default: defaultPaginationObject,
  }
)

const smartFilters = computed(() => smartFiltersData.value.items)
</script>

<template>
  <main>
    <UiBanner :title="$t('pages.products.label')" />
    <template v-if="route.name?.toString().startsWith('products___')">
      <!-- <ProductsFiltersSmartCarousel
        :smart-filters="smartFilters"
        :status="status"
      /> -->

      <div class="container mb-5 lg:mb-10">
        <ProductsFiltersSmartGrid
          :smart-filters="smartFilters"
          :status="status"
        />
      </div>
      <ProductsFilters />
    </template>
    <NuxtPage />
  </main>
</template>
